module.exports = __webpack_public_path__ + "static/media/date-filter.ebb1134a.png";